
	import {
		Component,
		Vue,
		Inject,
		Prop,
		Watch
	} from 'vue-property-decorator';
	import Util from '@/lib/util'
	import AbpBase from '@/lib/abpbase'
	@Component({
		components: {

		}
	})
	export default class NewsDetail extends AbpBase {
		iosUrl: string = 'https://yfpogis-appdown.oss-cn-shanghai.aliyuncs.com/download/ios/manifest.plist';
		androidUrl: string = 'https://yfpogis-appdown.oss-cn-shanghai.aliyuncs.com/download/android/app-release.apk';
		isInWeixin: boolean = false;
		isInIos: boolean = false;
		isTest: boolean = false;
		openApp: boolean = false;
		isNew:boolean=false;
		async created() {
			this.isInWeixin = this.isWeiXin();
			this.isInIos = this.isIos();
			this.isTest = this.$route.query.istest as any == "1";
			this.isNew = this.$route.query.isnew as any == "1";
			if(this.isNew){
				if(this.isTest){
					location.href = '/#/downloadnew?istest=1';
				}
				else{
					this.$router.push({
						path: 'downloadnew',						
					})
					//location.href = '/#/downloadnew';
				}
			}
			else{
				if (this.isTest) {
					this.iosUrl = 'https://yfpogis-appdown.oss-cn-shanghai.aliyuncs.com/download/ios_test/manifest.plist';
					this.androidUrl = 'https://yfpogis-appdown.oss-cn-shanghai.aliyuncs.com/download/android_test/app-release.apk';
				}
				this.openApp = (this.$route.query.open as any) == "1";
				if (!this.isInWeixin && this.openApp) {
					location.href = 'gis://yfpo.com';
				}
			}
			
		}
		download() {
			if (this.isIos()) {
				//alert(this.L('企业级应用需要您授权信任才正常使用'));

				location.href = "itms-services://?action=download-manifest&url=" + this.iosUrl;
			} else {
				location.href = this.androidUrl + "?time" + new Date().getTime();
			}
		}
		isWeiXin() {
			var ua = navigator.userAgent.toLowerCase() as any;
			if (ua.match(/MicroMessenger/i) == 'micromessenger') {
				return true; // 是微信端
			} else {
				return false;
			}
		}
		isAndroid() {
			var u = navigator.userAgent.toLowerCase();
			if (u.indexOf("android") > -1 || u.indexOf("linux") > -1) {
				if ((window as any).ShowFitness !== undefined) return true;
			}
			return false;
		}

		isIos() {
			var u = navigator.userAgent.toLowerCase();
			if (u.indexOf("iphone") > -1 || u.indexOf("ios") > -1 || u.indexOf("mac") > -1) {
				return true;
			}
			return false;
		}

	};
